<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Add / Edit</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.close('Close click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
          <form class="form" novalidate="" #f="ngForm">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                      <div class="card-body card-body-general padding-top-0px counselling-modal">
                        <div class="table-component">
                          <div class="table-responsive overflow-x-hidden">
                            <table class="table table-striped margin-left-zero">
                              <thead class="">
                                <tr>
                                  <th class="padding-top-0px padding-bottom-0px">Long Value</th>
                                  <th class="padding-top-0px padding-bottom-0px">Short Value</th>
                                  <th class="padding-top-0px padding-bottom-0px"></th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr class="padding-top-5px" *ngFor="let l of CurrentLongCodeTypeValueController">
                                  <td class="padding-top-0px padding-bottom-0px">
                                    {{l.LongValue}}
                                  </td>
                                  <td class="padding-top-0px padding-bottom-0px">
                                    {{l.ShortValue}}
                                  </td>
                                  <td class="padding-top-0px padding-bottom-0px">
                                    <!--<a (click)="EditCodeType(l)">
                                      <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i>
                                    </a>-->
                                    <div class="display-inline">
                                      <a class="nav-link-hand education-navlink" tooltip="Edit" (click)="EditCodeType(l)">
                                        <span class="badge font-size-12px"><i class="fas fa-pencil-alt"></i></span>
                                      </a>
                                    </div>
                                    <div class="display-inline">
                                      <a class="nav-link-hand font-size-12px color-Rejected" title="Remove" (click)="DeleteCodeType(l)">
                                        <i class="far fa-trash-alt nav-link-hand"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Long Value</label>
                      </div>

                      <div class="col-md-6 padding-left-0px padding-right-0px">
                        <input type="text" class="form-control" placeholder="Long Value"
                               id="LongValue"
                               [(ngModel)]="LongValue"
                               name="LongValue" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" required #UpdLongValue="ngModel">

                      </div>
                    </div>
                  </div>                  
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Short Value</label>
                      </div>

                      <div class="col-md-6 padding-left-0px padding-right-0px">
                        <input type="text" class="form-control" placeholder="Short Value"
                               id="ShortValue"
                               [(ngModel)]="ShortValue"
                               name="ShortValue" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" required #UpdShortValue="ngModel">

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="submit"
                        (click)="SaveCodeTypeValue()"
                        class="btn actions-btn-prime float-right font-size-13px">Save</button>
                <button type="button"
                        class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px"
                        (click)="activeModal.close('Close click')">Close</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
